import {
  CapacityClass,
  FacilityType,
  OrganizationType,
  OrganizationUserRole,
  ParkingSpaceMarking,
  ParkingSurface,
  StationType,
  TracingCapacity,
  TracingParkingSpace,
  TrafficSign,
  TypeOfManagement,
  UsageExtent,
  UserRole,
  UserStatus,
} from '@/modules/api/backend';
import { MapLayer } from '@/types/MapLayer';

export const I18N_DE = {
  MapLayer: {
    [MapLayer.PARKING_FACILITY]: 'Parkraumangebote',
    [MapLayer.PARK_AND_RIDE_FACILITY]: 'Park + Ride',
    [MapLayer.PICKUP_PARKING_FACILITY]: 'Parken + Mitnehmen',
    [MapLayer.TRAIN_STATION]: 'Bahnhof',
    [MapLayer.BUS_STATION]: 'Bushaltestelle',
  },
  UserStatus: {
    [UserStatus.ACTIVE]: 'aktiv',
    [UserStatus.INVITED]: 'eingeladen',
    [UserStatus.INACTIVE]: 'deaktiviert',
  },
  UserRole: {
    [UserRole.ADMIN]: 'Administrator*in',
    [UserRole.USER]: 'Benutzer*in',
  },
  TypeOfManagement: {
    [TypeOfManagement.DB_SERVICE_COUNTER]: 'Parkberechtigung am (DB-)Serviceschalter',
    [TypeOfManagement.NO_ONSITE_PARKING_PERMIT]: 'Parkberechtigung nicht vor Ort',
    [TypeOfManagement.PARKING_TICKET_MACHINE]: 'Parkscheinautomat',
    [TypeOfManagement.PARKING_METER]: 'Parkuhr',
    [TypeOfManagement.OTHER]: 'Sonstige',
  },
  ParkingSurface: {
    [ParkingSurface.ASPHALT]: 'Asphalt',
    [ParkingSurface.GRAVEL]: 'Schotter',
    [ParkingSurface.GRASS]: 'Wiese',
  },
  FacilityType: {
    [FacilityType.SEPARATE_AREA]: 'Separate Fläche',
    [FacilityType.ON_STREET_PARALLEL]: 'Im Straßenraum seitlich',
    [FacilityType.ON_STREET_ANGLED]: 'Fahrbahnrand in Schräg- oder Senkrechtaufstellung',
    [FacilityType.CURB_NO_MARKING]: 'Parken im Seitenstreifen (ohne Markierung)',
    [FacilityType.MARKED_BAY_PARALLEL]: 'Markierter Parkstreifen/Parkbuchten (Längsaufstellung)',
    [FacilityType.PARKING_GARAGE]: 'Parkhaus',
    [FacilityType.PARKDECK]: 'Parkdeck/Parkpalette',
    [FacilityType.OTHER]: 'Sonstige Parkfläche',
  },
  TrafficSign: {
    [TrafficSign.P_314]: 'P (Z 314 StVO)',
    [TrafficSign.PR]: 'P+R',
    [TrafficSign.NONE]: 'keine',
    [TrafficSign.OTHER]: 'Sonstige',
  },
  OrganizationUserRole: {
    [OrganizationUserRole.MANAGER]: 'Manager*in',
    [OrganizationUserRole.EDITOR]: 'Bearbeiter*in',
  },
  TracingParkingSpace: {
    [TracingParkingSpace.COUNTED]: 'gezählt',
    [TracingParkingSpace.ESTIMATED]: 'geschätzt',
    [TracingParkingSpace.AUTOMATED]: 'automatisiert',
  },
  TracingCapacity: {
    [TracingCapacity.COUNTED]: 'gezählt',
    [TracingCapacity.ESTIMATED]: 'geschätzt',
    [TracingCapacity.AUTOMATED]: 'automatisiert',
  },
  CapacityClass: {
    [CapacityClass.LOW]: 'niedrig',
    [CapacityClass.MEDIUM]: 'mittel',
    [CapacityClass.HIGH]: 'hoch',
    [CapacityClass.FULL]: 'voll',
  },
  UsageExtent: {
    [UsageExtent.LOW]: 'niedrig',
    [UsageExtent.MEDIUM]: 'mittel',
    [UsageExtent.HIGH]: 'hoch',
    [UsageExtent.UNCLEAR]: 'unklar',
  },
  ParkingSpaceMarking: {
    [ParkingSpaceMarking.NOT_MARKED]: 'nicht markiert',
    [ParkingSpaceMarking.PARTIALLY_MARKED]: 'teilweise markiert',
    [ParkingSpaceMarking.MARKED]: 'markiert',
  },
  OrganizationType: {
    [OrganizationType.MUNICIPAL]: 'Kommune',
    [OrganizationType.PARKING_OPERATOR]: 'Parkraumanbieter',
    [OrganizationType.THIRD_PARTY_SERVICE]: 'ext. Dienstleister',
    [OrganizationType.OTHER]: 'Andere',
  },

  StationType: {
    [StationType.TRAIN]: 'Bahn',
    [StationType.BUS]: 'Bus',
  },
};
